﻿'use strict';

/**
 * Controller for the footer
 * @memberOf components.footerModule
 * @namespace footerController
 */

footerController.$inject = ['$location'];

function footerController($location) {
    /* jshint validthis:true */
    var vm = this;
    vm.title = 'footerController';

    vm.currentDate = new Date();

    /**
    * Gets current date
    * @method getCurrentDate
    * @returns {Object} current date object
    * @memberOf components.footerModule.footerController
    */
    vm.getCurrentDate = function () { return vm.currentDate; };
}

module.exports = footerController;


//////////////////
// WEBPACK FOOTER
// ./source/angular/components/footer/footerController.js
// module id = 51
// module chunks = 0